import React from 'react';
import './css/bubble.css';

class Bubble extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div
        className="bubble"
        style={{
          transform: `translate(calc(100vw - 360px + ${this.props.x}px),calc(100vh - 470px + ${this.props.y}px))`,
        }}
      >
        <div className="message">{this.props.message}</div>
        <div className="button" onClick={this.props.close}>&nbsp;&nbsp;真乖&nbsp;&nbsp;</div>
        <div className="button1" onClick={this.props.close}>&nbsp;&nbsp;哈哈&nbsp;&nbsp;</div>
      </div>
    );
  }
}
export default Bubble;
